<fieldset class="fieldset" data-element="fieldset-date">
  <legend>Date</legend>

  <!-- CR-20260831-004: .param-changed = the date no longer matches what the tab's last run sent
       (mode toggle => yellow selected segment; picked value => yellow box background). -->
  <!-- [selectedItems] paired with the keys (CR-20260831-004 defect round 2): this group's items
       REBUILD when the loaded-date label moves, and ButtonGroup then re-feeds its stale
       self-synced selection objects — two segments lit at once, or none. Supplying the CURRENT
       selected object keeps the mutually-exclusive highlight single and present.
       Round 5 (owner: "change the way we highlight the things bound to it"): the kind-* classes
       drive a MODEL-OWNED selection paint by item index — the visual no longer depends on
       DevExtreme's internal .dx-item-selected at all, which the widget was observed to drop. -->
  <dx-button-group
    [class.param-changed]="this.kindChanged"
    [class.kind-loaded]="this.dateKind === 'loaded'"
    [class.kind-single]="this.dateKind === 'single'"
    [class.kind-range]="this.dateKind === 'range'"
    [items]="this.dateKindButtons"
    keyExpr="id"
    selectionMode="single"
    stylingMode="contained"
    [selectedItemKeys]="[this.dateKind]"
    [selectedItems]="this.dateKindSelectedItems"
    [disabled]="this.disabled"
    (onItemClick)="this.onDateKindClick($event)"
  ></dx-button-group>

  <!-- Single mode: ONE full-width tradeable-date box — no hint text (owner smoke
       2026-07-10: APG parity; "we invented something we don't need"). -->
  <div class="single-row" *ngIf="this.dateKind === 'single'">
    <dx-date-box data-element="date-single"
                 [class.param-changed]="this.valueChanged"
                 [value]="this.singleDate" type="date" displayFormat="EEE dd-MMM-yy"
                 [showClearButton]="true" [acceptCustomValue]="false" [openOnFieldClick]="true"
                 [disabled]="this.disabled" [disabledDates]="this.disabledDatesFn"
                 (onValueChanged)="this.onSingleDateChanged($event)"></dx-date-box>
  </div>

  <!-- Range mode: start → end (frame 06) -->
  <div class="pair" *ngIf="this.dateKind === 'range'">
    <dx-date-box data-element="date-range-start"
                 [class.param-changed]="this.valueChanged"
                 [value]="this.rangeStart" type="date" displayFormat="EEE dd-MMM-yy" placeholder="Start"
                 [showClearButton]="true" [acceptCustomValue]="false" [openOnFieldClick]="true"
                 [disabled]="this.disabled" [disabledDates]="this.disabledDatesFn"
                 (onValueChanged)="this.onRangeStartChanged($event)"></dx-date-box>
    <span class="range-arrow">→</span>
    <dx-date-box data-element="date-range-end"
                 [class.param-changed]="this.valueChanged"
                 [value]="this.rangeEnd" type="date" displayFormat="EEE dd-MMM-yy" placeholder="End"
                 [showClearButton]="true" [acceptCustomValue]="false" [openOnFieldClick]="true"
                 [disabled]="this.disabled" [disabledDates]="this.disabledDatesFn"
                 (onValueChanged)="this.onRangeEndChanged($event)"></dx-date-box>
  </div>

  <!-- Chain not arrived yet: weekend-only fallback in effect (family recipe 02daab720) -->
  <div class="dates-loading" data-element="dates-loading" *ngIf="this.expirationsLoading">
    <dx-load-indicator [height]="14" [width]="14"></dx-load-indicator>
    <span>Loading Expirations…</span>
  </div>
</fieldset>
